import service from '@/utils/server';
const modName='/rco/order/';

//查询方法
export const pageInfo = data => {
  return service({
    url: modName + 'rcoPageInfo',
    method: 'post',
    data
  });
};

//初始化更新对象
export const initUpdate = data => {
  return service({
    url: modName + 'editDetails',
    method: 'post',
    data
  });
};

export const exportData = data => {
  return service({
    url: modName + 'schExport',
    method: 'post',
    responseType: 'blob',
    data
  });
};

//取消
export const cancleSubmit = data => {
  return service({
    url: modName + 'cancel',
    method: 'post',
    data
  });
};



// WEBPACK FOOTER //
// ./src/page/bd/corn/reshipCornOrder/api/index.js